import React from 'react';
import LocalizedMessage from 'react-l10n';
// import PropTypes from 'prop-types';

function LiveStockFilterItem(props) {
    const { selected, onChange, name, filterKey, icon } = props;
    const iconLocation = window.filterIcons[icon];

    return (
        <label className='filter-option'>
            <input
                type='checkbox'
                name={filterKey}
                value={!selected}
                className='filter-option__input'
                checked={selected}
                onChange={onChange}
            />
            <span className='filter-option__container'>
                <span className='filter-option__text'>
                    <img src={iconLocation} />
                    <i className={`icon icon-${icon}`} />
                    <span>{name}</span>
                </span>
            </span>
        </label>
    );
}

function LiveStockFilter(props) {
    const { updateLivestockFilter, selectedFilters, showNLISFilter, showNAITFilter } = props;
    const availableFilters = ['Cattle', 'Sheep', 'Pig', 'Deer', 'Goat'];
    const baseFilterKey = 'LiveStockType';

    const isSelected = (name) => {
        return typeof selectedFilters[baseFilterKey] != 'undefined' &&
            typeof selectedFilters[baseFilterKey][name] != 'undefined'
            ? selectedFilters[baseFilterKey][name]
            : false;
    };

    const onFilterSelect = (e) => {
        updateLivestockFilter(e.target.name, e.target.value);
    };

    return (
        <div className='filter-box filter-livestock-type'>
            <div className='filter-box__label'>
                <LocalizedMessage id={'PRODUCT_LIST.FILTER'} />
            </div>
            <div className='filter-option__wrapper'>
                {availableFilters.map((item) => {
                    const itemKey = item.toLowerCase();
                    return (
                        <LiveStockFilterItem
                            key={itemKey}
                            name={item}
                            icon={itemKey}
                            filterKey={item}
                            selected={isSelected(item)}
                            onChange={onFilterSelect}
                        />
                    );
                })}
                {showNLISFilter === true && (
                    <LiveStockFilterItem
                        name={'NLIS'}
                        icon={'nlis'}
                        filterKey={'NLIS'}
                        selected={isSelected('NLIS')}
                        onChange={onFilterSelect}
                    />
                )}
                {showNAITFilter === true && (
                    <LiveStockFilterItem
                        name={'NAIT'}
                        icon={'nait'}
                        filterKey={'NLIS'}
                        selected={isSelected('NLIS')}
                        onChange={onFilterSelect}
                    />
                )}                
            </div>
        </div>
    );
}

function SortByFilterDropdownItem(props) {
    const {
        localizedText,
        icon,
        updateSortBy,
        sortBy,
        sortDirection,
        isActive,
    } = props;

    const onClick = (e) => {
        e.preventDefault();
        updateSortBy(sortBy, sortDirection);
    };

    return (
        <a
            className={`custom-dropdown__choices__item ${isActive === true &&
                'custom-dropdown__choices__item--active'}`}
            data-custom-dropdown-select
            data-value='price-asc'
            onClick={onClick}
        >
            <span className='custom-dropdown__icon'>
                <i className={`icon ${icon}`} />
            </span>
            <span className='custom-dropdown__text'>
                <LocalizedMessage id={localizedText} />
            </span>
        </a>
    );
}

function SortByFilter(props) {
    const { updateSortBy, availableSortBy } = props;

    const isSortActive = (sortItem) => {
        const { selectedSortBy } = props;
        const { sortBy, sortDirection } = selectedSortBy;

        if (
            sortBy == sortItem.sortBy &&
            sortDirection == sortItem.sortDirection
        ) {
            return true;
        }

        return false;
    };

    const getDisplayedSort = () => {
        const displayedSort = availableSortBy.find((item) => {
            return isSortActive(item);
        });

        if (typeof displayedSort != 'undefined' && displayedSort) {
            return displayedSort;
        }

        return availableSortBy[0];
    };

    const displayedSortBy = getDisplayedSort();

    return (
        <div className='filter-box filter-sort-by'>
            <div className='filter-box__label'>
                <LocalizedMessage id={'SORT_BY'} />
            </div>
            <div className='custom-dropdown'>
                <input type='hidden' name='SortBy' value='name-asc' />
                <a
                    href='javascript:void(0)'
                    className='custom-dropdown__selected'
                    data-toggle-custom-dropdown
                >
                    <span className='custom-dropdown__icon'>
                        <i className={`icon ${displayedSortBy.icon}`} />
                    </span>
                    <span className='custom-dropdown__text'>
                        <LocalizedMessage id={displayedSortBy.localizedText} />
                    </span>
                </a>
                <div className='custom-dropdown__choices'>
                    {availableSortBy.map((item, key) => {
                        return (
                            <SortByFilterDropdownItem
                                key={key}
                                isActive={isSortActive(item)}
                                updateSortBy={updateSortBy}
                                {...item}
                            />
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

function ListStyleFilter(props) {
    const { updateListStyle, selectedListStyle } = props;

    const isSelected = (name) => {
        return typeof selectedListStyle != 'undefined'
            ? selectedListStyle == name
            : false;
    };

    const onChange = (e) => {
        updateListStyle(e.target.value);
    };

    return (
        <div className='filter-box filter-list-style'>
            <div className='filter-box__label'>
                <LocalizedMessage id={'LIST_STYLE'} />
            </div>
            <div className='filter-option__wrapper filter-option__wrapper--grouped'>
                <label className='filter-option filter-option--small'>
                    <input
                        type='checkbox'
                        value='grid'
                        className='filter-option__input'
                        onChange={onChange}
                        checked={isSelected('grid')}
                    />
                    <span className='filter-option__container'>
                        <span className='filter-option__text'>
                            <i className='icon icon-grid' />
                        </span>
                    </span>
                </label>
                <label className='filter-option filter-option--small'>
                    <input
                        type='checkbox'
                        value='list'
                        className='filter-option__input'
                        onChange={onChange}
                        checked={isSelected('list')}
                    />
                    <span className='filter-option__container'>
                        <span className='filter-option__text'>
                            <i className='icon icon-list' />
                        </span>
                    </span>
                </label>
            </div>
        </div>
    );
}

class ProductListFilter extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const {
            showNLISFilter,
            showNAITFilter,
            hasLiveStockFilter,
            updateLivestockFilter,
            selectedFilters,
            updateSortBy,
            selectedSortBy,
            updateListStyle,
            selectedListStyle,
            availableSortBy,
        } = this.props;

        return (
            <React.Fragment>
                <div className='filter-box-wrapper'>
                    {hasLiveStockFilter === true ? (
                        <LiveStockFilter
                            updateLivestockFilter={updateLivestockFilter}
                            selectedFilters={selectedFilters}
                            showNLISFilter={showNLISFilter}
                            showNAITFilter={showNAITFilter}
                        />
                    ) : (
                        <React.Fragment>
                            <div className='filter-box filter-livestock-type hidden-sm hidden-xs' />
                        </React.Fragment>
                    )}
                    <SortByFilter
                        availableSortBy={availableSortBy}
                        updateSortBy={updateSortBy}
                        selectedSortBy={selectedSortBy}
                    />
                    <ListStyleFilter
                        updateListStyle={updateListStyle}
                        selectedListStyle={selectedListStyle}
                    />
                </div>
            </React.Fragment>
        );
    }
}

// default props
// ProductListFilter.defaultProps = {
//     isLoading: false,
//     list: [],
//     viewType: 'grid',
// };
// validate props
// ProductListFilter.propTypes = {
//     isLoading: PropTypes.bool,
//     list: PropTypes.array,
//     viewType: PropTypes.string,
// };

export default ProductListFilter;
